export const SUPPORTED_LOCALES = ["en", "hi"] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = "en";

export const REQUEST_LOCALE_HEADER = "x-itshealer-locale";

export const REQUEST_PATHNAME_HEADER = "x-itshealer-pathname";

export const LOCALE_LABELS: Record<AppLocale, string> = {
  en: "EN",
  hi: "हिं",
};

export function isAppLocale(value: string): value is AppLocale {
  return SUPPORTED_LOCALES.includes(value as AppLocale);
}

export function resolveAppLocale(value?: string | null): AppLocale {
  if (value && isAppLocale(value)) {
    return value;
  }

  return DEFAULT_LOCALE;
}
